import { Dialog, DialogContent, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubscriptionCard from "../Components/SubscriptionCard";
import { CheckCircle, HighlightOff } from "@mui/icons-material";
import axios from "axios";
import { decryptString, encryptString } from "../app.utils";
import { toast } from "react-toastify";
import { logout } from "../services/auth.service";
import ContainerLoader from "../Components/extras/ContainerLoader";
import { useLoader } from "../providers";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [selectedTab, setSelectedTab] = React.useState('subscriptions');
  const [openTransactionStatusDialog, setOpenTransactionStatusDialog] = useState(false);
  const [plans, setPlans] = useState<any>([]);
  const [paymentStatus, setPaymentStatus] = useState('');
  const { showLoader, hideLoader } = useLoader();

  const getPackages = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_NEST_URL}/users/public-plans`,
      )
      .then((response: any) => {
        if (response.data) {
          setPlans(response.data);
        }
      })
      .catch((error) => {
        toast.error('Failed to load plans.');
      });
  }

  useEffect(() => {
    getPackages();
  }, []);

  useEffect(() => {
    const transactionRefId = searchParams.get('transactionRefId') || '';
    if (transactionRefId) {
      checkPaymentStatus(transactionRefId);
    }
  }, [location.search]);

  const reloadScreen = () => {
    setOpenTransactionStatusDialog(false);
    searchParams.delete('transactionRefId');
    navigate({ search: searchParams.toString() });
    window.location.reload();
  }

  const checkPaymentStatus = async (id: string) => {
    showLoader();
    await axios
      .get(
        `${process.env.REACT_APP_API_NEST_URL}/payment/${id}`,
        {
          headers: {
            Authorization: `Bearer ${decryptString(localStorage.getItem('token'))}`
          },
        }
      )
      .then((res) => {
        hideLoader();
        if (res.data) {
          if (res.data.user) {
            localStorage.setItem('role', encryptString(res.data.user.role));
            localStorage.setItem('userPlanId', encryptString(res.data.user.planId));
          }
          if (res.data.invoice) {
            setPaymentStatus(res.data.invoice.Status);
          }
          setOpenTransactionStatusDialog(true);
        }
      })
      .catch((err) => {
        hideLoader();
        toast.error('Failed to fetch payment status.');
        if (err.response.status === 401) {
          logout();
        }
      });
  }
  return (
    <>
      <div className="flex flex-col gap-4 w-full">
        {/* <div className="flex flex-row justify-between items-center w-full text-lg font-bold p-3 rounded-container">
          <div className="flex flex-row gap-1">
            <span className={
              selectedTab === 'subscriptions' ? "text-white py-2 px-4 rounded-md shadow cursor-pointer min-w-max text-center bg-primary"
                : "bg-white py-1 px-4 min-w-max text-center text-primary cursor-pointer"}
              onClick={() => {
                searchParams.set('selectedTab', 'subscriptions');
                navigate({ search: searchParams.toString() }); setSelectedTab('subscriptions')
              }}>
              Subscriptions
            </span>
          </div>
        </div> */}
        {
          selectedTab === 'subscriptions' && (
            <div className="flex flex-col w-full rounded-container">
              <p className="text-2xl font-bold mb-4 p-3">Available Packages</p>
              <div className="flex flex-col justify-center items-center gap-4 w-full">
                {/* <p className="text-4xl">Ready to simplify your legal journey?</p> */}
                {/* <p className="text-4xl text-center">Choose your package today and unlock the clarity and support you deserve.</p>
                <p className="text-center">By subscribing to a EastLaw package, you agree to <a className='font-bold text-primary cursor-pointer hover:underline' onClick={() => { window.open('/terms-of-use', '_blank', 'noopener,noreferrer') }}>our terms</a> and <a className='font-bold text-primary cursor-pointer hover:underline' onClick={() => { window.open('/privacy-policy', '_blank', 'noopener,noreferrer') }}>privacy policy</a>.</p> */}
              <div className="grid grid-flow-row grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 justify-items-center mt-2 w-full">
                {plans && plans.map((plan: any) => (
                  <SubscriptionCard key={plan.name} plan={plan} />
                ))}
              </div>
              </div>
            </div>
          )
        }
      </div>
      <Dialog fullWidth open={openTransactionStatusDialog} onClose={reloadScreen}>
        <div className="flex flex-row bg-gradient-to-b from-[#41090b] to-[#150303] justify-end p-2 gap-2 items-center border-b-[0.1px] border-b-black border-opacity-50">
          <IconButton
            onClick={reloadScreen}
            size="small"
            className='action'
            sx={{ color: '#D91E25' }}>
            <HighlightOff fontSize='small' />
          </IconButton>
        </div>
        <DialogContent>
          <div className="flex flex-col justify-center items-center gap-4">
            {paymentStatus === 'success' ? (<CheckCircle sx={{ fontSize: '4rem', color: 'MediumSeaGreen' }} />) : (<CheckCircle sx={{ fontSize: '4rem', color: 'red' }} />)}
            <p className="text-center px-4">
              {paymentStatus === 'success' ? ('Payment has been processed successfully.') : (`Oops! Something went wrong. We couldn't process your payment at the moment. Please double-check your payment details and try again. If the issue persists, feel free to reach out to our support team at <b className="text-primary">support@eastlaw.pk</b> for assistance.`)}
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Settings;